import { useContext } from "react";
import { globalContext } from "../../global/Store";
import config from "../../config/Config.json";
import { GetMockUserRead } from "../../mock/user/UserRead";

export const useUserDataRepo = () => {
  const { globalState, dispatch, globalFunctions } = useContext(globalContext);

  const GetUser = (id: number) => {
    return new Promise(function (resolve, reject) {
      if (config.RunMode === "MOCK") {
        resolve(GetMockUserRead());
      } else {
        globalFunctions
          .CallPortalApi("User/Read", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + globalState.user.token,
            },
            body: JSON.stringify({
              Id: id,
            }),
          })
          .then(
            function (response: any) {
              resolve(response);
            },
            function (error: any) {
              reject(error);
            }
          );
      }
    });
  };

  const ResetPassword = (emailLinkId: string, email: string, newPassword: string) => {

    return new Promise(function (resolve, reject) {
      if (config.RunMode === "MOCK") {
        console.log("mock reset password");
      } else {
        globalFunctions
          .CallPortalApi("Authentication/ResetPassword", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              EmailLinkId: emailLinkId,
              Email: email,
              NewPassword : newPassword
            }),
          })
          .then(
            function (response: any) {
              resolve(response);
            },
            function (error: any) {
              reject(error);
            }
          );
      }
    });
  };

  const RequestPasswordReset = (email: string) => {


    console.log("in repo");

    return new Promise(function (resolve, reject) {
      if (config.RunMode === "MOCK") {
        console.log("mock reset password");
      } else {
        globalFunctions
          .CallPortalApi("Authentication/RequestPasswordReset?userEmail=" + email, {
            method: "GET",
            headers: {
              "Content-Type": "application/json"
            },
            body: null,
          })
          .then(
            function (response: any) {
              resolve(response);
            },
            function (error: any) {

              console.log("in repo error");
              reject(error);
            }
          );
      }
    });

  };

  return { GetUser, ResetPassword, RequestPasswordReset };
};
